module.exports = __webpack_public_path__ + "static/media/country_ch.18be79ed.webp";